/**
 * ResetIcon/index.js
 * desc: icon used to reset content
 * note: action icon via IconButton; defaults its tooltip + accessible name to the
 *       action label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const ResetIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="reset icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.reset.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 15 20" xmlns="http://www.w3.org/2000/svg"><path d="M7.273 7.273V4.545A5.459 5.459 0 001.818 10c0 .918.227 1.79.637 2.546l-1.328 1.327A7.21 7.21 0 010 10a7.27 7.27 0 017.273-7.273V0l3.636 3.636-3.636 3.637zm4.818.182l1.327-1.328A7.21 7.21 0 0114.546 10a7.27 7.27 0 01-7.273 7.273V20l-3.637-3.636 3.637-3.637v2.727A5.459 5.459 0 0012.727 10c0-.918-.236-1.782-.636-2.545z"/></svg>
    </IconButton>
);



export default ResetIcon;
